import type { ITag } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import ReportingSection from '../reporting/reporting-section';
import { SectionContainer } from './styles';
import type { ReportingForm } from './types';

interface ReportingSectionElementProps {
  form: ReportingForm;
  tagsSelectProps: {
    onChange: (values: ITag[]) => void;
    defaultValue: string[];
    hasError: boolean;
  };
}

const ReportingSectionElement = ({
  form,
  tagsSelectProps,
}: ReportingSectionElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <ReportingSection tagsSelectProps={tagsSelectProps} />
    </FormProvider>
  </SectionContainer>
);

export default memo(ReportingSectionElement);
